import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import React from 'react'

import Button from '@material-ui/core/Button'
import AddMappingForm from './AddMappingForm'
import { connect } from 'react-redux'

import { FaUserFriends, FaUser } from 'react-icons/fa'

import { createPrivateMapping, createCommonMapping } from '../../../../../../api/omnitecApi/omnitecRooms'

class LockTabTable extends React.Component {
    state = {
        open: false,
        selectedRoom: null
    }

    handleOpen = (type, remoteId) => {
        this.setState({
            open: {
                type,
                remoteId
            }
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleSave = data => {
        const { remoteId, type, roomId } = data

        const privateCreate = {
            remoteId,
            remoteName: this.props.locks.find(item => item.remoteId === remoteId).name,
            organizationId: this.props.currentOrganization,
            ourId: roomId
        }

        const commonCreate = {
            remoteId,
            remoteName: this.props.locks.find(item => item.remoteId === remoteId).name,
            organizationId: this.props.currentOrganization
        }

        if (type === 'private') {
            this.props.createPrivateMapping(privateCreate)
        }

        if (type === 'common') {
            this.props.createCommonMapping(commonCreate)
        }
    }

    calculateTableCell = item => {
        const { privateRooms, commonArea } = this.props
        const { remoteId } = item

        const commonAreaIds = commonArea.map(item => item.remoteId).includes(remoteId)
        const privateRoomIds = privateRooms.map(item => item.remoteId).includes(remoteId)
        const count = privateRooms.map(item => item.remoteId).filter(item => item === remoteId).length

        if (commonAreaIds && !privateRoomIds) {
            return (
                <div>
                    <FaUserFriends />
                </div>
            )
        }

        if (privateRoomIds && !commonAreaIds) {
            return (
                <div style={{ display: 'flex' }}>
                    <Button
                        variant="raised"
                        style={btnContainerStyle}
                        color="primary"
                        onClick={() => this.handleOpen('private', item.remoteId)}
                    >
                        <FaUser />
                    </Button>
                    <div style={{ padding: '7px', display: 'flex', alignItems: 'center' }}>
                        {`${count} X  `}
                        <FaUser />
                    </div>
                </div>
            )
        }

        const btnContainerStyle = {
            marginRight: '10px'
        }

        return (
            <div stlye={{ display: 'flex' }}>
                <Button
                    variant="raised"
                    style={btnContainerStyle}
                    color="primary"
                    onClick={() => this.handleOpen('common', item.remoteId)}
                >
                    <FaUserFriends />
                </Button>
                <Button
                    variant="raised"
                    style={btnContainerStyle}
                    color="primary"
                    onClick={() => this.handleOpen('private', item.remoteId)}
                >
                    <FaUser />
                </Button>
            </div>
        )
    }

    render() {
        const { classes, locks, easymsCategories } = this.props

        const listofrooms = easymsCategories.map(item => item.rooms.map(room => ({ ...room, category: item.id })))

        const listOfRoomsWithCategories = listofrooms.length
            ? listofrooms.reduce((prev, next) => prev.concat(next), [])
            : []

        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID замка</TableCell>
                            <TableCell>Название замка</TableCell>
                            <TableCell>Действие</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {locks.map(item => (
                            <TableRow hover key={item.remoteId}>
                                <TableCell>{item.remoteId}</TableCell>
                                <TableCell>{item.name}</TableCell>
                                <TableCell>{this.calculateTableCell(item)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <AddMappingForm
                    open={this.state.open}
                    easymsCategories={easymsCategories}
                    listOfRoomsWithCategories={listOfRoomsWithCategories}
                    handleClose={this.handleClose}
                    handleSave={this.handleSave}
                />
            </Paper>
        )
    }
}

const mapStateToProps = state => ({})

export default connect(
    mapStateToProps,
    { createPrivateMapping, createCommonMapping }
)(LockTabTable)



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/LockTab/LockTabTable/LockTabTable.js